module.exports = __webpack_public_path__ + "bc40d2c6a3a8311a408a99ab8990472a.png";